// Apolo IDE — AutoReviewNotice (S4 · E5-WS1-T02).
//
// Inline notice for an auto-reviewed tool call: blocked (with the reason that
// went back to the agent), escalated to the human (ask), or allowed. Rendered
// inside the turn. Surfaces use token-derived .rx-notice-* classes (redesign.css);
// only token-valued colors are inline.

import { ShieldAlert, ShieldQuestion, ShieldCheck } from 'lucide-react';

const META = {
  block: { color: 'var(--rx-del)', Icon: ShieldAlert, label: 'Ação bloqueada' },
  ask: { color: 'var(--rx-gold)', Icon: ShieldQuestion, label: 'Requer aprovação' },
  allow: { color: 'var(--rx-add)', Icon: ShieldCheck, label: 'Liberado' },
};

/**
 * @param {{ decision?: 'allow'|'block'|'ask', name?: string, reason?: string }} props
 */
export function AutoReviewNotice({ decision, name, reason }) {
  const meta = META[decision];
  if (!meta) return null;
  const { Icon } = meta;
  // block/ask interrupt the agent → assertive; allow is informational → polite.
  const role = decision === 'allow' ? 'status' : 'alert';

  return (
    <div
      data-testid="auto-review-notice"
      data-decision={decision}
      role={role}
      className={`rx-notice-${decision}`}
      style={{
        display: 'flex', alignItems: 'flex-start', gap: 9,
        border: '1px solid transparent', borderRadius: 'var(--rx-r-md)', padding: '9px 12px',
      }}
    >
      <Icon size={14} aria-hidden="true" style={{ color: meta.color, flexShrink: 0, marginTop: 1 }} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: meta.color }}>
          {meta.label}{name ? `: ${name}` : ''}
        </div>
        {reason && (
          <div style={{ fontSize: 11, color: 'var(--rx-tx2)', marginTop: 2, lineHeight: 1.4, wordBreak: 'break-word' }}>
            {reason}
          </div>
        )}
      </div>
    </div>
  );
}

export default AutoReviewNotice;
